// extracted by mini-css-extract-plugin
module.exports = {"container":"task_container__3uLvg","taskTitle":"task_taskTitle__3iBzm","icon":"task_icon__3fvH8"};